import { RequestDetailsComponent } from './request-details/request-details.component';
import { InvitationRightsComponent } from './invitation-rights/invitation-rights.component';
import { BulkInviteHomeComponent } from './bulk-invite-home/bulk-invite-home.component';
import { BulkInvitePreviewComponent } from './bulk-invite-preview/bulk-invite-preview.component';
import { BulkInviteComponent } from './bulk-invite/bulk-invite.component';
import { IndividualInviteComponent } from './individual-invite/individual-invite.component';
import { InviteComponent } from './invite/invite.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndividualInviteStatusComponent } from './individual-invite-status/individual-invite-status.component';
import { InviteDetailComponent } from './invite-detail/invite-detail.component';
import { HistoryComponent } from './history/history.component';

const routes: Routes = [
  // { path: '', component: IndividualInviteComponent },
  { path: 'individual-invite', component: InviteComponent },

  { path: 'individual-invite/invite', component: IndividualInviteComponent },
  {
    path: 'individual-invite/status',
    component: IndividualInviteStatusComponent,
  },

  {path: 'bulk-invite',component: BulkInviteHomeComponent,},

  { path: 'bulk-invite/invite', component: BulkInviteComponent },
  { path: 'bulk-invite/preview', component: BulkInvitePreviewComponent },

  { path: 'history', component: HistoryComponent },
  { path: 'detail', component: InviteDetailComponent },

  {path:'invitation-rights',component:InvitationRightsComponent},
  {path:'invitation-rights/detail',component:RequestDetailsComponent}
];
@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VmsRoutingModule {}
